<template>
  <MainLayout class="ranking white pt-4">
    <GlobalRanking background="white" />
  </MainLayout>
</template>

<style scoped>
>>>.container.customWidth {
  padding: 0;
}
</style>

<script>
import MainLayout from '@/layouts/MainLayout.vue';

import GlobalRanking from '@/components/ranking/GlobalRanking.vue';

export default {
  name: 'Ranking',
  components: {
    MainLayout,
    GlobalRanking,
  },
};
</script>
